import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/timeline/hiring.svg'
import _imports_1 from '@/assets/timeline/arrow.svg'
import _imports_2 from '@/assets/timeline/edit.svg'
import _imports_3 from '@/assets/timeline/callenge.svg'
import _imports_4 from '@/assets/icons/target.svg'


const _hoisted_1 = { class: "flex flex-col pt-3 animate__animated animate__fadeIn" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex items-center justify-center px-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-row items-center" }
const _hoisted_7 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_8 = { class: "pl-1" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" by ")
const _hoisted_10 = { class: "font-bold pl-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_12 = { class: "text-gray-500 italic pl-2" }
const _hoisted_13 = {
  key: 1,
  class: "flex flex-row items-center py-2 bg-green-100"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "icon stage"
  })
], -1)
const _hoisted_15 = { class: "flex flex-row items-center" }
const _hoisted_16 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = { class: "pl-1" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" was Hired by ")
const _hoisted_20 = { class: "font-bold pl-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_22 = { class: "text-gray-500 italic pl-2" }
const _hoisted_23 = {
  key: 2,
  class: "flex flex-row items-center py-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "icon creation"
  })
], -1)
const _hoisted_25 = { class: "flex flex-row items-center" }
const _hoisted_26 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Uploaded by ")
const _hoisted_28 = { class: "font-bold pl-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_30 = { class: "text-gray-500 italic pl-2" }
const _hoisted_31 = {
  key: 3,
  class: "flex flex-row items-center py-2"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "icon stage"
  })
], -1)
const _hoisted_33 = { class: "flex flex-row items-center" }
const _hoisted_34 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Edited candidate information by ")
const _hoisted_36 = { class: "font-bold pl-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_38 = { class: "text-gray-500 italic pl-2" }
const _hoisted_39 = { class: "flex items-center justify-center px-3" }
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "flex flex-row items-center" }
const _hoisted_42 = { class: "inline" }
const _hoisted_43 = { class: "flex items-center justify-center bg-primary text-white rounded-full w-8 h-8 text-sm" }
const _hoisted_44 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "Applied via job board ", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_47 = { class: "text-gray-500 italic pl-2" }
const _hoisted_48 = {
  key: 5,
  class: "w-full break-words"
}
const _hoisted_49 = { class: "flex flex-row items-center py-2" }
const _hoisted_50 = { class: "flex items-center justify-center pl-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  style: {"color":"#a0a3bd"},
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
  })
], -1)
const _hoisted_52 = { class: "pl-3" }
const _hoisted_53 = { class: "flex flex-row items-center" }
const _hoisted_54 = { class: "flex flex-row items-center text-xs pl-3 space-x-2" }
const _hoisted_55 = { class: "font-bold text-xs" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" added a comment ")
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-xs italic" }, "•", -1)
const _hoisted_58 = { class: "text-gray-500 text-xs italic" }
const _hoisted_59 = { class: "w-full flex flex-col space-x-3 items-center my-1 justify-end" }
const _hoisted_60 = { class: "overflow-ellipsis whitespace-pre-line text-xs text-left w-11/12 pl-8" }
const _hoisted_61 = {
  key: 0,
  class: "p-2 w-11/12 flex-row grid grid-cols-4 gap-2"
}
const _hoisted_62 = ["href"]
const _hoisted_63 = ["src"]
const _hoisted_64 = {
  key: 6,
  class: "flex flex-col"
}
const _hoisted_65 = { class: "flex flex-row items-center py-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-5 h-5 text-gray-500"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
    })
  ])
], -1)
const _hoisted_67 = { class: "flex flex-row items-center" }
const _hoisted_68 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" The meeting invite ")
const _hoisted_70 = ["href"]
const _hoisted_71 = { class: "font-bold pl-1" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_73 = { class: "text-gray-500 italic pl-2" }
const _hoisted_74 = {
  key: 7,
  class: "flex flex-row items-center py-2"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "icon creation"
  })
], -1)
const _hoisted_76 = { class: "flex flex-row items-center" }
const _hoisted_77 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", null, " Uploaded by Axelerate AI ", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_80 = { class: "text-gray-500 italic pl-2" }
const _hoisted_81 = {
  key: 8,
  class: "flex flex-row items-center py-2"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "icon challenge"
  })
], -1)
const _hoisted_83 = { class: "flex flex-row items-center" }
const _hoisted_84 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" The ")
const _hoisted_86 = { class: "font-bold pl-1" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" challenge was sent by ")
const _hoisted_88 = { class: "font-bold pl-1" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_90 = { class: "text-gray-500 italic pl-2" }
const _hoisted_91 = {
  key: 9,
  class: "flex flex-row items-center py-2"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "icon challenge"
  })
], -1)
const _hoisted_93 = { class: "flex flex-row items-center" }
const _hoisted_94 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" The challenge ")
const _hoisted_96 = { class: "font-bold pl-1" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" started by ")
const _hoisted_98 = { class: "font-bold pl-1" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_100 = { class: "text-gray-500 italic pl-2" }
const _hoisted_101 = {
  key: 10,
  class: "flex flex-row items-center py-2"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "icon challenge"
  })
], -1)
const _hoisted_103 = { class: "flex flex-row items-center" }
const _hoisted_104 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_105 = /*#__PURE__*/_createTextVNode(" The challenge ")
const _hoisted_106 = { class: "font-bold pl-1" }
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" was not started by ")
const _hoisted_108 = { class: "font-bold pl-1" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_110 = { class: "text-gray-500 italic pl-2" }
const _hoisted_111 = {
  key: 11,
  class: "flex flex-row items-center py-2"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "icon challenge"
  })
], -1)
const _hoisted_113 = { class: "flex flex-row items-center" }
const _hoisted_114 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" The challenge ")
const _hoisted_116 = { class: "font-bold pl-1" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode(" has been answered by ")
const _hoisted_118 = { class: "font-bold pl-1" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_120 = { class: "text-gray-500 italic pl-2" }
const _hoisted_121 = {
  key: 12,
  class: "flex flex-row items-center py-2"
}
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "icon challenge"
  })
], -1)
const _hoisted_123 = { class: "flex flex-row items-center" }
const _hoisted_124 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_125 = /*#__PURE__*/_createTextVNode(" The ")
const _hoisted_126 = { class: "font-bold pl-1" }
const _hoisted_127 = /*#__PURE__*/_createTextVNode(" challenge was re-sent by ")
const _hoisted_128 = { class: "font-bold pl-1" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_130 = { class: "text-gray-500 italic pl-2" }
const _hoisted_131 = {
  key: 13,
  class: "flex flex-row items-center py-2 bg-yellow-50"
}
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "icon creation"
  })
], -1)
const _hoisted_133 = { class: "flex flex-row items-center" }
const _hoisted_134 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_135 = /*#__PURE__*/_createTextVNode(" Job closed by ")
const _hoisted_136 = { class: "font-bold pl-1" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_138 = { class: "text-gray-500 italic pl-2" }
const _hoisted_139 = {
  key: 14,
  class: "flex flex-row items-center py-2 bg-green-50"
}
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "icon creation"
  })
], -1)
const _hoisted_141 = { class: "flex flex-row items-center" }
const _hoisted_142 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_143 = /*#__PURE__*/_createTextVNode(" Job re-opened by ")
const _hoisted_144 = { class: "font-bold pl-1" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_146 = { class: "text-gray-500 italic pl-2" }
const _hoisted_147 = {
  key: 15,
  class: "flex flex-col"
}
const _hoisted_148 = { class: "flex flex-row items-center py-2" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-5 h-5 text-gray-500"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
    })
  ])
], -1)
const _hoisted_150 = { class: "flex flex-row items-center" }
const _hoisted_151 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_152 = /*#__PURE__*/_createTextVNode(" Meeting scheduled by ")
const _hoisted_153 = { class: "font-bold pl-1" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_155 = { class: "text-gray-500 italic pl-2" }
const _hoisted_156 = { class: "w-full flex flex-col items-center my-1 pl-24 text-xs" }
const _hoisted_157 = { class: "grid grid-cols-2 w-full" }
const _hoisted_158 = { class: "flex flex-row" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Date", -1)
const _hoisted_160 = { class: "ml-4" }
const _hoisted_161 = { class: "flex flex-row" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Time", -1)
const _hoisted_163 = { class: "ml-4" }
const _hoisted_164 = { class: "grid grid-cols-2 w-full mt-2" }
const _hoisted_165 = { class: "flex flex-row justify-start items-start" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Duration", -1)
const _hoisted_167 = { class: "ml-4" }
const _hoisted_168 = { class: "flex flex-row" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Organizer", -1)
const _hoisted_170 = { class: "ml-4" }
const _hoisted_171 = { class: "flex flex-row w-full mt-2" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Attendees", -1)
const _hoisted_173 = { class: "grid grid-cols-3 gap-2 ml-4" }
const _hoisted_174 = { class: "flex flex-col ml-2" }
const _hoisted_175 = { class: "text-gray-500" }
const _hoisted_176 = { class: "flex flex-row items-center w-full mt-2" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mr-4" }, "Meeting URL", -1)
const _hoisted_178 = ["href"]
const _hoisted_179 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Meeting link", -1)
const _hoisted_180 = [
  _hoisted_179
]
const _hoisted_181 = ["onClick"]
const _hoisted_182 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-5 h-5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
  })
], -1)
const _hoisted_183 = [
  _hoisted_182
]
const _hoisted_184 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Refresh for meeting url", -1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-5 h-5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
  })
], -1)
const _hoisted_186 = [
  _hoisted_184,
  _hoisted_185
]
const _hoisted_187 = { key: 16 }
const _hoisted_188 = { class: "flex flex-row items-center py-2" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center px-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    style: {"color":"#a0a3bd"},
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    })
  ])
], -1)
const _hoisted_190 = { class: "flex flex-row items-center" }
const _hoisted_191 = { class: "flex flex-row items-center text-xs pl-4" }
const _hoisted_192 = { class: "font-bold pl-1" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("span", { class: "pl-1" }, "added a comment", -1)
const _hoisted_194 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 italic pl-2" }, "•", -1)
const _hoisted_195 = { class: "text-gray-500 italic pl-2" }
const _hoisted_196 = { class: "p-4 bg-purple-50 rounded-lg my-1" }
const _hoisted_197 = { class: "overflow-ellipsis whitespace-pre-line text-xs" }
const _hoisted_198 = {
  key: 17,
  class: "flex flex-row items-center py-2"
}
const _hoisted_199 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-px bg-gray-300" }, null, -1)
const _hoisted_200 = [
  _hoisted_199
]
const _hoisted_201 = {
  key: 18,
  class: "flex flex-row items-center py-2"
}
const _hoisted_202 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-px bg-gray-300" }, null, -1)
const _hoisted_203 = [
  _hoisted_202
]
const _hoisted_204 = { key: 19 }
const _hoisted_205 = { key: 0 }
const _hoisted_206 = { key: 0 }
const _hoisted_207 = { class: "flex flex-row items-center py-2" }
const _hoisted_208 = { class: "flex items-center justify-center pl-3" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  style: {"color":"#a0a3bd"},
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
  })
], -1)
const _hoisted_210 = { class: "pl-3" }
const _hoisted_211 = { class: "flex flex-row items-center" }
const _hoisted_212 = { class: "flex flex-row items-center text-xs pl-3 space-x-2" }
const _hoisted_213 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-xs" }, "Email", -1)
const _hoisted_214 = /*#__PURE__*/_createTextVNode(" sent by ")
const _hoisted_215 = { class: "font-bold text-xs" }
const _hoisted_216 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-xs italic" }, "•", -1)
const _hoisted_217 = { class: "text-gray-500 text-xs italic" }
const _hoisted_218 = { class: "w-full flex flex-row space-x-3 items-center my-1 justify-end" }
const _hoisted_219 = { class: "overflow-ellipsis whitespace-pre-line text-xs text-left w-11/12 pl-8" }
const _hoisted_220 = ["onClick"]
const _hoisted_221 = ["innerHTML"]
const _hoisted_222 = ["onClick"]
const _hoisted_223 = { key: 1 }
const _hoisted_224 = { class: "flex flex-row items-center py-2" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  style: {"color":"#a0a3bd"},
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
  })
], -1)
const _hoisted_226 = { class: "pl-3" }
const _hoisted_227 = { class: "flex flex-row items-center" }
const _hoisted_228 = { class: "flex flex-row items-center text-xs pl-3 space-x-2" }
const _hoisted_229 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-xs" }, "Email", -1)
const _hoisted_230 = /*#__PURE__*/_createTextVNode(" sent by ")
const _hoisted_231 = { class: "font-bold text-xs" }
const _hoisted_232 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-xs italic" }, "•", -1)
const _hoisted_233 = { class: "text-gray-500 text-xs italic" }
const _hoisted_234 = { class: "w-full flex flex-row space-x-3 items-center my-1 justify-end" }
const _hoisted_235 = { class: "overflow-ellipsis whitespace-pre-line text-xs text-left w-11/12 pl-8" }
const _hoisted_236 = ["onClick"]
const _hoisted_237 = ["innerHTML"]
const _hoisted_238 = ["onClick"]
const _hoisted_239 = { class: "flex flex-row items-center justify-between mb-3" }
const _hoisted_240 = ["onClick"]
const _hoisted_241 = ["onClick"]
const _hoisted_242 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Highlighter = _resolveComponent("Highlighter")!
  const _component_EmailComposer = _resolveComponent("EmailComposer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeline, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `timeline-item-${i + 1}`
      }, [
        (
          item.event_type === 'job_candidate_with_inactivity' ||
          item.event_type === 'job_candidate_meeting_feedback_remainder'
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (item.event_type === 'job_candidate_stage_change')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["flex flex-row items-center py-2", item.sourceable.stage_name === 'Rejected' && 'bg-red-50'])
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: _ctx.buildImageStage(item.sourceable.stage_name),
                        alt: "icon stage"
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_Avatar, {
                        name: `${item.staff.first_name} ${item.staff.last_name}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", null, "Moved to " + _toDisplayString(item.sourceable.stage_name), 1),
                        _createElementVNode("span", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("span", _hoisted_10, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                        ]),
                        _hoisted_11,
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              (item.event_type === 'job_candidate_hired')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_Avatar, {
                        name: `${item.staff.first_name} ${item.staff.last_name}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(`${item.sourceable.first_name} ${item.sourceable.last_name}`), 1),
                        _createElementVNode("span", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("span", _hoisted_20, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                        ]),
                        _hoisted_21,
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
            item.event_type === 'creation' ||
            item.event_type === 'job_candidate_added'
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_Avatar, {
                        name: `${item.staff.first_name} ${item.staff.last_name}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", null, [
                          _hoisted_27,
                          _createElementVNode("span", _hoisted_28, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                        ]),
                        _hoisted_29,
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'update')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_Avatar, {
                        name: `${item.staff.first_name} ${item.staff.last_name}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("span", null, [
                          _hoisted_35,
                          _createElementVNode("span", _hoisted_36, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                        ]),
                        _hoisted_37,
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'candidate_applied_to_job')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass(["flex flex-row items-center py-2", item.sourceable.stage_name === 'Rejected' && 'bg-red-50'])
                  }, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("img", {
                        src: _ctx.buildImageStage(item?.sourceable?.stage_name),
                        alt: "icon stage"
                      }, null, 8, _hoisted_40)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.getInitials(
                    `${item.sourceable?.candidate.first_name} ${item.sourceable?.candidate?.last_name}`
                  )), 1)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _hoisted_46,
                        _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              (item.event_type === 'comment_creation')
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_Avatar, {
                            name: `${item.staff.first_name} ${item.staff.last_name}`,
                            variant: "xs"
                          }, null, 8, ["name"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("span", null, [
                            _createElementVNode("span", _hoisted_55, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name} `), 1),
                            _hoisted_56
                          ]),
                          _hoisted_57,
                          _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("span", _hoisted_60, [
                        _createVNode(_component_Highlighter, {
                          class: "my-highlight",
                          highlightClassName: "text-primary-dark font-semibold bg-white",
                          searchWords: 
                  item?.sourceable?.content?.match(
                    /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi
                  ) || []
                ,
                          autoEscape: true,
                          textToHighlight: item.sourceable.content
                        }, null, 8, ["searchWords", "textToHighlight"])
                      ]),
                      (item?.sourceable.images)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.sourceable.images, (image, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "w-40 mt-4",
                                key: `timeline-item-${i + 1}`
                              }, [
                                _createElementVNode("a", {
                                  href: image.url,
                                  target: "_blank",
                                  class: "flex w-40 h-44"
                                }, [
                                  _createElementVNode("img", {
                                    class: "w-40 h-44 object-cover rounded-lg border",
                                    src: image.url
                                  }, null, 8, _hoisted_63)
                                ], 8, _hoisted_62)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'job_candidate_meeting_url_sent')
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_Avatar, {
                          name: `${item.staff.first_name} ${item.staff.last_name}`,
                          variant: "xs"
                        }, null, 8, ["name"]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("span", null, [
                            _hoisted_69,
                            _createElementVNode("a", {
                              href: item.sourceable?.url,
                              class: "text-primary hover:underline",
                              target: "_blank"
                            }, "link", 8, _hoisted_70),
                            _createTextVNode(" for the " + _toDisplayString(item.sourceable.title) + " was sent to the candidate by ", 1),
                            _createElementVNode("span", _hoisted_71, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                          ]),
                          _hoisted_72,
                          _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'ai_sourcing_job_candidate_added')
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_Avatar, {
                        name: "Artificial Intelligence",
                        variant: "xs"
                      }),
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _hoisted_79,
                        _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'job_candidate_code_challenge_sent')
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      _createVNode(_component_Avatar, {
                        name: `${item.staff.first_name} ${item.staff.last_name}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("span", null, [
                          _hoisted_85,
                          _createElementVNode("span", _hoisted_86, _toDisplayString(`${item.sourceable.job_challenge_title}`), 1),
                          _hoisted_87,
                          _createElementVNode("span", _hoisted_88, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                        ]),
                        _hoisted_89,
                        _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'job_candidate_code_challenge_started')
                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                    _hoisted_92,
                    _createElementVNode("div", _hoisted_93, [
                      _createVNode(_component_Avatar, {
                        name: `${_ctx.candidateName}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("span", null, [
                          _hoisted_95,
                          _createElementVNode("span", _hoisted_96, _toDisplayString(`${item.sourceable.job_challenge_title}`), 1),
                          _hoisted_97,
                          _createElementVNode("span", _hoisted_98, _toDisplayString(`${_ctx.candidateName}`), 1)
                        ]),
                        _hoisted_99,
                        _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
            item.event_type ===
            'job_candidate_code_challenge_hasnt_started_reminder'
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                    _hoisted_102,
                    _createElementVNode("div", _hoisted_103, [
                      _createVNode(_component_Avatar, {
                        name: `${_ctx.candidateName}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("span", null, [
                          _hoisted_105,
                          _createElementVNode("span", _hoisted_106, _toDisplayString(`${item.sourceable.job_challenge_title}`), 1),
                          _hoisted_107,
                          _createElementVNode("span", _hoisted_108, _toDisplayString(`${_ctx.candidateName}`), 1)
                        ]),
                        _hoisted_109,
                        _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'job_candidate_code_challenge_result')
                ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                    _hoisted_112,
                    _createElementVNode("div", _hoisted_113, [
                      _createVNode(_component_Avatar, {
                        name: `${_ctx.candidateName}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("span", null, [
                          _hoisted_115,
                          _createElementVNode("span", _hoisted_116, _toDisplayString(`${item.sourceable.job_challenge_title}`), 1),
                          _hoisted_117,
                          _createElementVNode("span", _hoisted_118, _toDisplayString(`${_ctx.candidateName}`), 1)
                        ]),
                        _hoisted_119,
                        _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'job_candidate_code_challenge_resent')
                ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                    _hoisted_122,
                    _createElementVNode("div", _hoisted_123, [
                      _createVNode(_component_Avatar, {
                        name: `${item.staff.first_name} ${item.staff.last_name}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("span", null, [
                          _hoisted_125,
                          _createElementVNode("span", _hoisted_126, _toDisplayString(`${item.sourceable.job_challenge_title}`), 1),
                          _hoisted_127,
                          _createElementVNode("span", _hoisted_128, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                        ]),
                        _hoisted_129,
                        _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'job_closed')
                ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                    _hoisted_132,
                    _createElementVNode("div", _hoisted_133, [
                      _createVNode(_component_Avatar, {
                        name: `${item.staff.first_name} ${item.staff.last_name}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_134, [
                        _createElementVNode("span", null, [
                          _hoisted_135,
                          _createElementVNode("span", _hoisted_136, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                        ]),
                        _hoisted_137,
                        _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'job_reopened')
                ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                    _hoisted_140,
                    _createElementVNode("div", _hoisted_141, [
                      _createVNode(_component_Avatar, {
                        name: `${item.staff.first_name} ${item.staff.last_name}`,
                        variant: "xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_142, [
                        _createElementVNode("span", null, [
                          _hoisted_143,
                          _createElementVNode("span", _hoisted_144, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                        ]),
                        _hoisted_145,
                        _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.event_type === 'job_candidate_meeting_scheduled')
                ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, [
                      _hoisted_149,
                      _createElementVNode("div", _hoisted_150, [
                        _createVNode(_component_Avatar, {
                          name: `${item.staff.first_name} ${item.staff.last_name}`,
                          variant: "xs"
                        }, null, 8, ["name"]),
                        _createElementVNode("div", _hoisted_151, [
                          _createElementVNode("span", null, [
                            _hoisted_152,
                            _createElementVNode("span", _hoisted_153, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                          ]),
                          _hoisted_154,
                          _createElementVNode("span", _hoisted_155, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_156, [
                      _createElementVNode("div", _hoisted_157, [
                        _createElementVNode("div", _hoisted_158, [
                          _hoisted_159,
                          _createElementVNode("span", _hoisted_160, _toDisplayString(_ctx.getDate(new Date(item.sourceable.start_time * 1000))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_161, [
                          _hoisted_162,
                          _createElementVNode("span", _hoisted_163, _toDisplayString(_ctx.getTime(
                      new Date(item.sourceable.start_time * 1000),
                      new Date(item.sourceable.end_time * 1000)
                    )), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("div", _hoisted_165, [
                          _hoisted_166,
                          _createElementVNode("span", _hoisted_167, _toDisplayString((item.sourceable.end_time * 1000 -
                      item.sourceable.start_time * 1000) /
                    60000) + " minutes ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_168, [
                          _hoisted_169,
                          _createElementVNode("span", _hoisted_170, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name}`), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_171, [
                        _hoisted_172,
                        _createElementVNode("div", _hoisted_173, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sourceable?.attendees?.attendees, (attendee, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "flex flex-row items-center"
                            }, [
                              _createVNode(_component_Avatar, {
                                name: Object.keys(attendee)[0],
                                variant: "xs"
                              }, null, 8, ["name"]),
                              _createElementVNode("div", _hoisted_174, [
                                _createElementVNode("span", null, _toDisplayString(Object.keys(attendee)[0]), 1),
                                _createElementVNode("span", _hoisted_175, _toDisplayString(attendee[Object.keys(attendee)[0]][0]), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_176, [
                        _hoisted_177,
                        (item.sourceable.meeting_url)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: item.sourceable.meeting_url
                            }, _hoisted_180, 8, _hoisted_178))
                          : _createCommentVNode("", true),
                        (item.sourceable.meeting_url)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.copyUrlToClipboard(item.sourceable.meeting_url)),
                              class: "text-primary ml-2"
                            }, _hoisted_183, 8, _hoisted_181))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args))),
                              class: "flex flex-row items-center text-primary"
                            }, _hoisted_186))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.ValidateJobComment(item.event_type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                    _createElementVNode("div", _hoisted_188, [
                      _hoisted_189,
                      _createElementVNode("div", _hoisted_190, [
                        _createVNode(_component_Avatar, {
                          name: `${item.staff.first_name} ${item.staff.last_name}`,
                          variant: "xs"
                        }, null, 8, ["name"]),
                        _createElementVNode("div", _hoisted_191, [
                          _createElementVNode("span", null, [
                            _createElementVNode("span", _hoisted_192, _toDisplayString(`${item.staff.first_name} ${item.staff.last_name} `), 1),
                            _hoisted_193
                          ]),
                          _hoisted_194,
                          _createElementVNode("span", _hoisted_195, _toDisplayString(_ctx.formatedDateMoment(item.updated_at)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_196, [
                      _createElementVNode("span", _hoisted_197, [
                        _createVNode(_component_Highlighter, {
                          class: "my-highlight",
                          highlightClassName: "text-primary-dark font-semibold bg-white",
                          searchWords: 
                  item?.sourceable?.content?.match(
                    /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi
                  ) || []
                ,
                          autoEscape: true,
                          textToHighlight: item.sourceable.content
                        }, null, 8, ["searchWords", "textToHighlight"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.ValidateJobComment(item.event_type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_198, _hoisted_200))
                : _createCommentVNode("", true),
              (!_ctx.ValidateJobComment(item.event_type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_201, _hoisted_203))
                : _createCommentVNode("", true),
              (item.event_type === 'job_candidate_conversation')
                ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                    (item.sourceable?.replies?.messages?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sourceable?.replies?.messages, (message, msg_idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: message.id
                            }, [
                              (msg_idx < 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                    _createElementVNode("div", _hoisted_207, [
                                      _createElementVNode("div", _hoisted_208, [
                                        _hoisted_209,
                                        _createElementVNode("div", _hoisted_210, [
                                          _createVNode(_component_Avatar, {
                                            name: `${message.from.first_name} ${message.from.last_name}`,
                                            variant: "xs"
                                          }, null, 8, ["name"])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_211, [
                                        _createElementVNode("div", _hoisted_212, [
                                          _createElementVNode("span", null, [
                                            _hoisted_213,
                                            _hoisted_214,
                                            _createElementVNode("span", _hoisted_215, _toDisplayString(`${message.from.first_name} ${message.from.last_name}`), 1)
                                          ]),
                                          _hoisted_216,
                                          _createElementVNode("span", _hoisted_217, _toDisplayString(_ctx.formatedDateMoment(message.date)), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_218, [
                                      _createElementVNode("span", _hoisted_219, [
                                        (!_ctx.refsReplies[msg_idx][message.id])
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(message.snippet) + "... ", 1),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (_ctx.showFullMessage(msg_idx, message.id, true)),
                                                class: "text-primary"
                                              }, " View full message ", 8, _hoisted_220)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (_ctx.refsReplies[msg_idx][message.id])
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("span", {
                                                innerHTML: message.body
                                              }, null, 8, _hoisted_221),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (_ctx.showFullMessage(msg_idx, message.id, false)),
                                                class: "text-primary"
                                              }, " Hide message ", 8, _hoisted_222)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (msg_idx > 0 && _ctx.refsConversations[i][item.id])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                                    _createElementVNode("div", _hoisted_224, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["flex items-center justify-center", 'pl-' + (3 + msg_idx)])
                                      }, [
                                        _hoisted_225,
                                        _createElementVNode("div", _hoisted_226, [
                                          _createVNode(_component_Avatar, {
                                            name: `${message.from.first_name} ${message.from.last_name}`,
                                            variant: "xs"
                                          }, null, 8, ["name"])
                                        ])
                                      ], 2),
                                      _createElementVNode("div", _hoisted_227, [
                                        _createElementVNode("div", _hoisted_228, [
                                          _createElementVNode("span", null, [
                                            _hoisted_229,
                                            _hoisted_230,
                                            _createElementVNode("span", _hoisted_231, _toDisplayString(`${message.from.first_name} ${message.from.last_name}`), 1)
                                          ]),
                                          _hoisted_232,
                                          _createElementVNode("span", _hoisted_233, _toDisplayString(_ctx.formatedDateMoment(message.date)), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_234, [
                                      _createElementVNode("span", _hoisted_235, [
                                        (!_ctx.refsReplies[msg_idx][message.id])
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(message.snippet) + "... ", 1),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (_ctx.showFullMessage(msg_idx, message.id, true)),
                                                class: "text-primary"
                                              }, " View full message ", 8, _hoisted_236)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (_ctx.refsReplies[msg_idx][message.id])
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("span", {
                                                innerHTML: message.body
                                              }, null, 8, _hoisted_237),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (_ctx.showFullMessage(msg_idx, message.id, false)),
                                                class: "text-primary"
                                              }, " Hide message ", 8, _hoisted_238)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_239, [
                            (
                  item.sourceable?.replies?.messages?.length > 1 &&
                  !_ctx.refsConversations[i][item.id]
                )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.moreEmailReplies(i, item.id, true, item)),
                                  class: "text-primary"
                                }, " View replies (" + _toDisplayString(item.sourceable?.replies?.messages?.length - 1) + ") ", 9, _hoisted_240))
                              : _createCommentVNode("", true),
                            (_ctx.refsConversations[i][item.id])
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.moreEmailReplies(i, item.id, false)),
                                  class: "text-primary"
                                }, " Hide replies ", 8, _hoisted_241))
                              : _createCommentVNode("", true),
                            (_ctx.refsConversations[i][item.id])
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: "bg-primary rounded text-white p-1",
                                  onClick: ($event: any) => (_ctx.createReplyComposer(i, item.id, true))
                                }, " Reply ", 8, _hoisted_242))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.refsConversationsReplyComposer[i][item.id])
                            ? (_openBlock(), _createBlock(_component_EmailComposer, {
                                key: 0,
                                threadId: item?.sourceable?.replies?.id,
                                cc: item?.sourceable?.replies?.participants_cc,
                                subject: item?.sourceable?.replies?.subject,
                                body: item.sourceable.replies.messages.slice(-1)[0].body
                              }, null, 8, ["threadId", "cc", "subject", "body"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
      ]))
    }), 128))
  ]))
}